import { all } from 'redux-saga/effects'
import { AirtableTrackingSagas } from './airtableTracking'

export default function* rootSaga() {
  yield all([...AirtableTrackingSagas])
}



// WEBPACK FOOTER //
// ./src/sagas/index.js